export default __webpack_public_path__ + "static/media/rescale_overview.d72c10ba.pdf";